module.exports = __webpack_public_path__ + "static/media/figure-section-eight-mobile.03cbb5bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/figure-section-eight-mobile.png
// module id = 565
// module chunks = 0